import React, { Component } from 'react';
import axios from '~/data/http/axios';
import Button from '~/Common-Objects/UI/Forms/Button/Button'
import Icons from '~/Common-Objects/UI/Icons/index'
import LoadingIcons from '~/Common-Objects/LoadingIcons/loadingIcon1'
import Select from '~/Common-Objects/UI/Forms/Select/Select'

class BounceActions extends Component {
    constructor(props) {
        super(props);
        this.state = {
            action: '',
            actioning: false
        }

        this.editValue = this.editValue.bind(this)
        this.finish = this.finish.bind(this)
    }

    editValue(ev) {
        this.setState({ [ev.currentTarget.name]: ev.currentTarget.value })
    }

    finish() {
        this.setState({ actioning: true })
        axios.put('/campaign/' + this.props.campaignId + '/bounces', {
            action: this.state.action
        }).then(() => {
            this.setState({
                actioning: false
            })
            this.props.finish()
        })
    }

    render() {
        var actions = [{ label: 'Delete', value: 'delete' }, { label: 'Denylist', value: 'blacklist' }]
        let actionFriendly = "";
        if (this.state.action) actionFriendly = this.state.action[0].toUpperCase() + this.state.action.substring(1);
        return (
            <div>
                <h4 className="mar-b25">Perform an action on all the hard bounces from this campaign</h4>

                <Select outerClassName="mar-b25" data={actions} disabled={this.state.actioning} value={this.state.action} placeholder="Select Action" name="action" onChange={this.editValue} />

                {!!this.state.action && !this.state.actioning && <Button text={actionFriendly} onClick={this.finish} iconRight={<Icons icon="arrowRight" />} />}
                {this.state.actioning && <LoadingIcons iconType="2" />}
            </div>
        );
    }
}

export default BounceActions;